import * as yup from 'yup';

export const calculatorValidationSchema = yup.object().shape({
  threeMonthsSales: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('This field is required'),
  seasonal: yup.boolean().required('This field is required'),
  averageUnitPerPrice: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('This field is required'),
  averageUnitCost: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('This field is required'),
  email: yup.string().email().required().trim(),
});
